<template>
  <nav class="navigation">
    <a
      class="navigation__item"
      tabindex="0"
      @click="goToHome"
    >
      {{ navigationText['main'] }}
    </a>
    <a
      tabindex="0"
      class="navigation__item"
      href="https://www.transportes.gob.es/"
    >
      MINISTERIO
    </a>
  </nav>
</template>

<script setup>
// #region VUE
import {inject, computed} from 'vue';
import {useRouter} from 'vue-router';
import {useStore} from 'vuex';
// #endregion

// #region STTEDRA
import {
  useDev,
} from '@sttedra_ui/framework';
// #endregion

// #region COMPONENTS COMPOSABLES
import {useDebounceFn} from '@vueuse/core';
// #endregion

// #region Params, Ref, Reactives, Computed
const appState$$ = inject('appState$$');
const router = useRouter();
const store = useStore();
const navigationText = computed(() => store.getters['text/getSectionTexts']('navigation'));
// #endregion

// #region Functions
const goToHome = useDebounceFn(goToHomeFn, 200, {maxWait: 700});
async function goToHomeFn() {
  try {
    // appState$$.setLoginApp(appState$$.isLogged);
    appState$$.currentRequest = null;

    const dataRoute = {};
    router.push({
      name: `Home`,
      ...dataRoute,
    });
  } catch (error) {
    useDev.error('[Navigation.vue] goToHome', error);
  }
}
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.navigation{
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  width: 100%;

  @include media("<=desktop") {
    display: none !important;
  }

  &__item{
    color: $pv__color--black;
    cursor: pointer;
    font-size: $pv__fs--large !important;
    font-weight: 500;
    margin-left: 0.5rem;
    padding: $brand__boxspace--small;
    position: relative;
    text-decoration: none;

    &::after {
      background: $pv__color--black;
      bottom: 0;
      content: "";
      height: 2.5px;
      left: 50%;
      position: absolute;
      -webkit-transition: all 0.3s;
      -o-transition: all 0.3s;
      transition: all 0.3s;
      width: 0;
    }
  }
}
</style>
